
function inputItems(elments) {
    $(elments).focus(function(){
        $(this).parents('.form-group').addClass('focused');
    });

    $(elments).blur(function(){
        var inputValue = $(this).val();
        if ( inputValue == "" ) {
            $(this).removeClass('filled');
            $(this).parents('.form-group').removeClass('focused');  
        } else {
            $(this).addClass('filled');
        }
    })
};

module.exports = inputItems;